import { createFileRoute } from '@tanstack/react-router';

import { FormToolEditor } from '@/features/client-side-tools/components/FormToolEditor';

export const Route = createFileRoute(
  '/_baseLayout/agent-tools/client-side/$formToolId/edit',
)({
  component: ClientSideFormToolEditPage,
});

function ClientSideFormToolEditPage() {
  const { formToolId } = Route.useParams();

  return <FormToolEditor formToolId={formToolId} />;
}
